import {configureStore, combineReducers} from "@reduxjs/toolkit";

//Import default states
import { generalState, pageState, menuState, pagePasswordState, authState } from "./includes/states";
import { registerStates } from "../app/states";

const states = registerStates({
	generalState,
	pageState,
	menuState,
	pagePasswordState,
	authState
});

export const store = configureStore({
	reducer: combineReducers(states),
	devTools: process.env.NODE_ENV !== 'production'
})
